import React from 'react';
import ReportingGiftCardsSalesPage from '../components/ReportingGiftCardsSalesPage';

const ReportingGiftCardsSalesApp = (props) => (
  <ReportingGiftCardsSalesPage {...props} />
);

export default ReportingGiftCardsSalesApp;
